import { styled } from "@linaria/react";
import { Tooltip } from "@pages/CCP/components/Tooltip";
import React from "react";
import { themeDefault } from "src/theme-revamp";
import { JsxElement } from "typescript";
import MyinfoComponent from "./myinfoComponent";

interface IProp {
  data: Array<IChildDataModel>;
  onRestart?: ()=>void
}

interface IChildDataModel {
  title: string;
  flagColor: "#00AC95" | "#C50000";
  sideButton: "SELECT" | "RESTART" | null | undefined
  itemType: string;
  onChange: (payload: {itemType:string, index: number, item: any})=>void;
  onSelect: (e:any)=>void,
  onRestart?: ()=>void 
  toolTip?: {
    title: string, 
    content: string
  }
  childrenData: Array<IChildData> | any;
}

interface IChildData {}

function ListMyinfoChild({ data }: IProp) {

  return <>{data.map((x) => {
    return( 
    <>
    <Title flagColor={x.flagColor}><span>{x.title}</span>
    {x?.toolTip && (
            <Tooltip  title={x.toolTip.title} isIcon={true}>
              <p>{x.toolTip.content}</p>
            </Tooltip>
          )}
    </Title>
    {
      x?.childrenData && x?.childrenData.map((childData:any, index:number)=>(

        <MyinfoComponent itemType={x.itemType} onChange={x?.onChange} index={index} onSelect={x.onSelect}  childData={childData} sideButton={x.sideButton} onRestart={x?.onRestart}/>
      ))}
    </>);
  })}</>
}

export default ListMyinfoChild;


const Title = styled.div<{flagColor: string}>`
  position: relative;
  display: flex;
  align-items: center;
  column-gap: 16px;
  padding-left: 16px;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 24px;
  .toolTip {
  .top {
    .tooltipHeader {
      color: #DFC2DD;
    }
  }}
  &::before{
    border-radius: 4px;
    content: "";
    width: 6px;
    height: 100%;
    position: absolute;
    left: 0;
    background-color: ${prop=>prop.flagColor||""};
  }
`